/**
 * Application-specific wrapper for useAuth hook
 * 
 * This wrapper is now a simple re-export since Cognito config is handled
 * by the AuthProvider via context. No custom logic needed.
 * 
 * Usage:
 * ```typescript
 * import { useAuth } from '@/hooks/useAppAuth'
 * 
 * function MyComponent() {
 *   const { isAuthenticated, signinRedirect, signoutRedirect } = useAuth()
 *   // Cognito logout is automatically handled by the library
 * }
 * ```
 */

import { useAuth as useLibraryAuth } from '@revalize/auth/frontend'

/**
 * Wrapper hook that provides the library's useAuth
 * 
 * No configuration needed - AuthProvider handles Cognito config via context
 * 
 * @returns Auth state and methods with automatic Cognito logout support
 */
export function useAuth(): ReturnType<typeof useLibraryAuth> {
  return useLibraryAuth()
}

